import { Injectable } from '@angular/core';
import { McaDocumentType } from '@shared/core';
import { BaseServiceClient } from '@shared/data';
import { Observable } from 'rxjs';
import { MedicalDocumentationBodyDtoUnion } from '../interface/dto/documentation/medical-documentation-body-dto';
import { MedicalDocumentationResponseDto } from '../interface/dto/documentation/medical-documentation-response-dto';

@Injectable({
    providedIn: 'root',
})
export class DocumentationServiceClientService extends BaseServiceClient {
    private readonly BaseUrl = `${this.ApiBaseUrl}${this.appConstants.httpClient.legacyMedicalBase}`;

    public setMedicalDocumentation(dto: MedicalDocumentationBodyDtoUnion): Observable<MedicalDocumentationResponseDto> {
        return this.post(`${this.BaseUrl}/medical-documentation`, dto);
    }

    public uploadDocument(file: File, documentType?: McaDocumentType, description?: string): Observable<string> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        if (documentType) {
            formData.append('documentType', String(documentType));
        }
        if (description) {
            formData.append('description', description);
        }

        return this.post<string>(`${this.BaseUrl}/medical-documentation/documents`, formData, { responseType: 'text' });
    }
}
